import {Translation} from '../i18n/Translation';
import {ComponentWithoutChildren} from '../react/types';
import {SubmitButton, SubmitButtonProps} from './SubmitButton';

export type SaveButtonProps = Omit<SubmitButtonProps, 'aria-label' | 'data-translate'>;

export const SaveButton: ComponentWithoutChildren<SaveButtonProps> = (props: SaveButtonProps) => {
  return (
    <Translation keys="common:button.save">
      {(save) => (
        <SubmitButton {...props} aria-label={save}>
          {save}
        </SubmitButton>
      )}
    </Translation>
  );
};
